export const ShortcutPrefixRegex = /^[a-zA-Z]+:/gm;
